import { CreateColumn } from '../../../../Services/agGrid/createColumn';
import { Box, Chip, Typography } from '@mui/material';
import React from 'react';

const priorityTone = (priority) => {
  if (priority === 'P1') return { bg: 'rgba(239,68,68,0.10)', fg: '#b91c1c' };
  if (priority === 'P2') return { bg: 'rgba(59,130,246,0.10)', fg: '#1d4ed8' };
  return { bg: 'rgba(148,163,184,0.20)', fg: '#475569' };
};

const statusTone = (status) => {
  if (status === '시작전')
    return { bg: 'rgba(239,68,68,0.10)', fg: '#b91c1c', bd: 'rgba(239,68,68,0.25)' };
  if (status === '진행중')
    return { bg: 'rgba(168,85,247,0.10)', fg: '#6d28d9', bd: 'rgba(168,85,247,0.25)' };
  if (status === '완료')
    return { bg: 'rgba(148,163,184,0.20)', fg: '#475569', bd: 'rgba(148,163,184,0.35)' };
  if (status === '배포완료')
    return { bg: 'rgba(148,163,184,0.20)', fg: '#475569', bd: 'rgba(148,163,184,0.35)' };
  return { bg: 'rgba(148,163,184,0.20)', fg: '#475569', bd: 'rgba(148,163,184,0.35)' };
};

export const getColumnDefs = () => {
  return [
    CreateColumn('priority', '우선순위', 'left', 110, false, false, false, 'custom', {
      cellRenderer: (params) => {
        const v = params.value ?? '';
        const t = priorityTone(String(v));
        return (
          <Box sx={{ display: 'flex', alignItems: 'center', height: '100%', py: 0.5 }}>
            <Box
              sx={{
                width: 24,
                height: 24,
                borderRadius: '9999px',
                bgcolor: t.bg,
                color: t.fg,
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: 12,
                fontWeight: 800,
              }}
            >
              {v}
            </Box>
          </Box>
        );
      },
      width: 110,
      minWidth: 110,
      sortable: true,
      filter: true,
    }),

    CreateColumn('category', '카테고리', 'left', 140, false, false, false, 'custom', {
      cellRenderer: (params) => (
        <Box sx={{ py: 0.5 }}>
          <Typography sx={{ fontSize: 12, fontWeight: 600, color: 'text.secondary' }}>
            {params.value ?? ''}
          </Typography>
        </Box>
      ),
      width: 140,
      minWidth: 140,
      sortable: true,
      filter: true,
    }),

    CreateColumn('title', '업무명', 'left', 420, false, false, false, 'custom', {
      cellRenderer: (params) => (
        <Box sx={{ py: 0.5 }}>
          <Typography
            sx={{
              fontSize: 14,
              fontWeight: 700,
              color: 'text.primary',
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
            }}
            title={params.value ?? ''}
          >
            {params.value ?? ''}
          </Typography>
        </Box>
      ),
      flex: 1,
      minWidth: 260,
      sortable: true,
      filter: true,
    }),

    CreateColumn('status', '상태', 'left', 160, false, false, false, 'custom', {
      cellRenderer: (params) => {
        const s = String(params.value ?? '');
        const t = statusTone(s);
        return (
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              width: '100%',
              height: '100%',
              py: 0.5,
            }}
          >
            <Chip
              label={s}
              size="small"
              sx={{
                height: 22,
                fontSize: 11,
                fontWeight: 800,
                bgcolor: t.bg,
                color: t.fg,
                border: `1px solid ${t.bd}`,
              }}
            />
          </Box>
        );
      },
      width: 160,
      minWidth: 140,
      sortable: true,
      filter: true,
      cellClass: 'ag-center-aligned',
    }),

    CreateColumn('assigneeNm', '담당자', 'left', 140, false, false, false, 'custom', {
      cellRenderer: (params) => (
        <Box sx={{ py: 0.5 }}>
          <Typography sx={{ fontSize: 12, fontWeight: 700, color: 'text.primary' }}>
            {params.value ?? ''}
          </Typography>
        </Box>
      ),
      width: 140,
      minWidth: 120,
      sortable: true,
      filter: true,
    }),
  ];
};

export default { getColumnDefs };

